// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddToOptionModal_PotentialOptionsQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  designPackageVersionId: Types.Scalars['ID']['input'];
  placeholderTliId: Types.Scalars['ID']['input'];
}>;


export type AddToOptionModal_PotentialOptionsQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, potentialPersonalizationOptions: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined, personalizationPlaceholders: Array<{ __typename?: 'TakeoffLineItem', id: string, personalizationPlaceholderControlledSlots: Array<{ __typename?: 'TakeoffLineItem', id: string }> }> }> } };

export type AddToOptionModal_ReadyPlanOptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined, personalizationPlaceholders: Array<{ __typename?: 'TakeoffLineItem', id: string, personalizationPlaceholderControlledSlots: Array<{ __typename?: 'TakeoffLineItem', id: string }> }> };

export const AddToOptionModal_ReadyPlanOptionGroupFragmentDoc = gql`
    fragment AddToOptionModal_ReadyPlanOptionGroup on ReadyPlanOptionGroup {
  id
  name
  personalizationType {
    code
    name
  }
  personalizationPlaceholders {
    id
    personalizationPlaceholderControlledSlots {
      id
    }
  }
}
    `;
export const AddToOptionModal_PotentialOptionsDocument = gql`
    query AddToOptionModal_PotentialOptions($designPackageId: ID!, $designPackageVersionId: ID!, $placeholderTliId: ID!) {
  designPackage(id: $designPackageId, versionId: $designPackageVersionId) {
    id
    potentialPersonalizationOptions(placeholderTliId: $placeholderTliId) {
      ...AddToOptionModal_ReadyPlanOptionGroup
    }
  }
}
    ${AddToOptionModal_ReadyPlanOptionGroupFragmentDoc}`;

/**
 * __useAddToOptionModal_PotentialOptionsQuery__
 *
 * To run a query within a React component, call `useAddToOptionModal_PotentialOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddToOptionModal_PotentialOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddToOptionModal_PotentialOptionsQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      designPackageVersionId: // value for 'designPackageVersionId'
 *      placeholderTliId: // value for 'placeholderTliId'
 *   },
 * });
 */
export function useAddToOptionModal_PotentialOptionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables> & ({ variables: AddToOptionModal_PotentialOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>(AddToOptionModal_PotentialOptionsDocument, options);
      }
export function useAddToOptionModal_PotentialOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>(AddToOptionModal_PotentialOptionsDocument, options);
        }
// @ts-ignore
export function useAddToOptionModal_PotentialOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>;
export function useAddToOptionModal_PotentialOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddToOptionModal_PotentialOptionsQuery | undefined, AddToOptionModal_PotentialOptionsQueryVariables>;
export function useAddToOptionModal_PotentialOptionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>(AddToOptionModal_PotentialOptionsDocument, options);
        }
export type AddToOptionModal_PotentialOptionsQueryHookResult = ReturnType<typeof useAddToOptionModal_PotentialOptionsQuery>;
export type AddToOptionModal_PotentialOptionsLazyQueryHookResult = ReturnType<typeof useAddToOptionModal_PotentialOptionsLazyQuery>;
export type AddToOptionModal_PotentialOptionsSuspenseQueryHookResult = ReturnType<typeof useAddToOptionModal_PotentialOptionsSuspenseQuery>;
export type AddToOptionModal_PotentialOptionsQueryResult = ApolloReactCommon.QueryResult<AddToOptionModal_PotentialOptionsQuery, AddToOptionModal_PotentialOptionsQueryVariables>;